import {GridLogBookApi, ListLogBookApi} from "api/logBook";
import {queryKeys} from 'react-query/constant';
import {useInfiniteQuery, useQuery, useQueryClient} from "@tanstack/react-query";


export const useLogBook = (patientId) => {
    return useInfiniteQuery(
        [queryKeys.logBookList, patientId],
        ({pageParam = 1}) => ListLogBookApi(pageParam, patientId),
        {
            keepPreviousData: true,
            staleTime: 4 * (60 * 1000), // 4 minutes
            getNextPageParam: (lastPage, pages) => {
                if (parseInt(lastPage.length) < 20) {
                    return false
                }
                return pages.length + 1;
            },
            onError: (error) => console.log(error.response.message)

        }
    );
};
export const usePreFetchGridLogBook = (patientId, page, filterChoice) => {
    const queryClient = useQueryClient();
    const fetchData = GridLogBookApi();
    return queryClient.prefetchQuery([queryKeys.logBookGrid, patientId, page + 1, filterChoice],
        () => fetchData(patientId, page + 1))
}
export const useGridLogBook = (patientId, page, filterChoice) => {
    console.log(patientId, page)
    const fetchData = GridLogBookApi()
    return useQuery(
        [queryKeys.logBookGrid, patientId, page, filterChoice],
        () => fetchData(patientId, page),
        {
            keepPreviousData: true,
            // default cache time is 5minute
            staleTime: 4 * (60 * 1000), // 4 minutes
        }
    );
}
